import React, { useState, useEffect, useContext } from "react";
import { Container, Card, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaArrowLeft,
  FaTicketAlt,
  FaPlus,
  FaComments,
  FaTrashAlt,
  FaPaperPlane,
  FaTimes,
} from "react-icons/fa";
import { FiUser, FiHeadphones } from "react-icons/fi";
import "../../../../assets/css/customer/subscreens/account/Support&Help.css";
import BottomNavigation from "../../../../components/general/bottomnavigation/BottomNavigation";
import AppContext from "../../../../contexts/AppContext";
import axios from "axios";
import MyNavbar from "../../../../components/general/mynavbar/MyNavbar";

const SupportHelpPage = () => {
  const navigate = useNavigate();
  const { baseUrl, customerAuthToken } = useContext(AppContext);
  const [showForm, setShowForm] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [message, setMessage] = useState("");
  const [contactForm, setContactForm] = useState({ name: "", email: "" });
  const [category, setCategory] = useState("");
  const [chatOpen, setChatOpen] = useState(false);
  const [chatTicket, setChatTicket] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");

  const savedCustomer = JSON.parse(localStorage.getItem("loggedInCustomer"));
  const customerId = savedCustomer?.id;

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm((prev) => ({ ...prev, [name]: value }));
  };

  const viewAllTickets = () => {
    axios
      .get(
        `${baseUrl}/customer/support/viewAllTickets?customer_id=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${customerAuthToken}`,
          },
        },
      )
      .then((res) => setTickets(res.data?.supporthelp || []))
      .catch(() => setTickets([]));
  };

  const deleteTicket = (id) => {
    const formdata = new FormData();
    formdata.append("ticketid", id);
    formdata.append("customer_id", customerId);
    axios
      .post(`${baseUrl}/customer/support/deleteTicket`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${customerAuthToken}`,
        },
      })
      .then(() => {
        toast.error("Ticket Deleted");
        viewAllTickets();
      })
      .catch((e) => console.log(e));
  };

  const createTicket = () => {
    if (!category) {
      toast.warning("Please select a category.");
      return;
    }
    if (!message.trim()) {
      toast.warning("Please enter a description.");
      return;
    }

    const formdata = new FormData();
    formdata.append("customer_id", customerId);
    formdata.append("name", contactForm.name);
    formdata.append("email", contactForm.email);
    formdata.append("category", category);
    formdata.append("description", message);
    formdata.append("status", "In Progress");

    axios
      .post(`${baseUrl}/customer/support/createTicket`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${customerAuthToken}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          toast.success("Ticket Created Successfully!");
          viewAllTickets();
          setShowForm(false);
          setCategory("");
          setMessage("");
          setContactForm({ name: "", email: "" });
        } else {
          toast.error(res.data?.msg || "Failed to create ticket.");
        }
      })
      .catch(() => toast.error("Something went wrong. Try again."));
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    createTicket();
  };

  const openChat = (ticket) => {
    setChatTicket(ticket);
    setChatMessages([]);
    setChatOpen(true);
    fetchMessages(ticket.id);
  };

  const fetchMessages = (ticketId) => {
    axios
      .get(`${baseUrl}/customer/support/getMessages`, {
        params: { ticket_id: ticketId, customer_id: customerId },
        headers: {
          Authorization: `Bearer ${customerAuthToken}`,
        },
      })
      .then((res) => setChatMessages(res.data?.messages || []))
      .catch((error) => console.log(error));
  };

  const sendChatMessage = () => {
    if (!chatInput.trim()) return;

    const formdata = new FormData();
    formdata.append("ticket_id", chatTicket.id);
    formdata.append("customer_id", customerId);
    formdata.append("message", chatInput);
    setChatInput("");

    axios
      .post(`${baseUrl}/customer/support/sendMessage`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${customerAuthToken}`,
        },
      })
      .then(() => fetchMessages(chatTicket.id))
      .catch(() => toast.error("Failed to send message."));
  };

  const handleChatKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendChatMessage();
    }
  };

  const ticketCategories = [
    "Order Issue",
    "Payment Problem",
    "Account Help",
    "Technical Support",
  ];
  const statusClasses = {
    "In Progress": "status-pending",
    Active: "status-active",
    Closed: "status-closed",
  };

  useEffect(() => {
    viewAllTickets();
  }, []);

  useEffect(() => {
    if (chatOpen && chatTicket) {
      const interval = setInterval(() => fetchMessages(chatTicket.id), 5000);
      return () => clearInterval(interval);
    }
  }, [chatOpen, chatTicket]);

  return (
    <>
      <MyNavbar />
      <div className="support-help-page">
        <ToastContainer />
        <Container>
          <div className="support-shell-container">
            <div className="support-header">
              <button className="back-btn" onClick={() => navigate("/account")}>
                <FaArrowLeft size={20} />
              </button>
              <h1>Support & Help</h1>
              <div></div>
            </div>

            <div className="my-tickets-section">
              <div className="tickets-header">
                <h3 className="section-title">
                  <FaTicketAlt className="section-icon" /> My Tickets
                </h3>
                <button
                  className="generate-ticket-btn"
                  onClick={() => setShowForm(!showForm)}
                >
                  <FaPlus className="btn-icon" /> Generate Ticket
                </button>
              </div>

              {tickets.length > 0 && !showForm && (
                <div className="tickets-grid">
                  {tickets.map((ticket, index) => (
                    <Card key={index} className="ticket-card">
                      <div className="ticket-card-header">
                        <span className="ticket-number-small">
                          #{ticket.id}
                        </span>
                        <div className="ticket-actions">
                          <span
                            className={`status-badge ${statusClasses[ticket.status] || "status-pending"}`}
                          >
                            {ticket.status}
                          </span>
                          <button
                            className="ticket-action-btn chat-btn"
                            onClick={() => openChat(ticket)}
                          >
                            <FaComments />
                          </button>
                          <button
                            className="ticket-action-btn delete-btn"
                            onClick={() => deleteTicket(ticket.id)}
                          >
                            <FaTrashAlt />
                          </button>
                        </div>
                      </div>
                      <div className="ticket-card-body">
                        <h5 className="ticket-category">{ticket.category}</h5>
                        <p className="ticket-message-preview">
                          {ticket.description}
                        </p>
                        <div className="ticket-card-meta">
                          <span className="ticket-date">
                            {new Date(ticket.created_at).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              )}

              {tickets.length === 0 && !showForm && (
                <div className="no-tickets">
                  <FaTicketAlt size={48} />
                  <p>No tickets generated yet</p>
                </div>
              )}
            </div>

            {showForm && (
              <div className="contact-form-section">
                <Card className="contact-form-card">
                  <Form onSubmit={handleContactSubmit}>
                    <Form.Group className="form-group">
                      <Form.Label>Your Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter your name"
                        value={contactForm.name}
                        onChange={handleContactChange}
                        required
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>Email Address *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={contactForm.email}
                        onChange={handleContactChange}
                        required
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>Category *</Form.Label>
                      <Form.Select
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        className="form-input"
                        required
                      >
                        <option value="">Select a category</option>
                        {ticketCategories.map((cat, idx) => (
                          <option key={idx} value={cat}>
                            {cat}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>Description*</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Describe your issue in detail..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                        className="form-textarea"
                      />
                    </Form.Group>
                    <div className="form-buttons">
                      <Button
                        type="button"
                        className="cancel-btn"
                        onClick={() => setShowForm(false)}
                      >
                        Cancel
                      </Button>
                      <Button type="submit" className="submit-btn">
                        <FaTicketAlt className="btn-icon" /> Generate Ticket
                      </Button>
                    </div>
                  </Form>
                </Card>
              </div>
            )}
          </div>
          <BottomNavigation />
        </Container>

        {chatOpen && chatTicket && (
          <div className="sh-chat-overlay" onClick={() => setChatOpen(false)}>
            <div className="sh-chat-modal" onClick={(e) => e.stopPropagation()}>
              <div className="sh-chat-header">
                <div className="sh-chat-header-info">
                  <div className="sh-chat-header-icon">
                    <FiHeadphones />
                  </div>
                  <div>
                    <h4>Support Team</h4>
                    <span>
                      Ticket #{chatTicket.id} · {chatTicket.category}
                    </span>
                  </div>
                </div>
                <button
                  className="sh-chat-close"
                  onClick={() => setChatOpen(false)}
                >
                  <FaTimes />
                </button>
              </div>

              <div className="sh-chat-messages">
                {chatMessages.map((msg) => (
                  <div
                    key={msg.id}
                    className={`sh-chat-msg ${msg.sender === "chcustomer" ? "sh-msg-right" : "sh-msg-left"}`}
                  >
                    <div className="sh-chat-avatar">
                      {msg.sender === "chcustomer" ? (
                        <FiUser />
                      ) : (
                        <FiHeadphones />
                      )}
                    </div>
                    <div className="sh-chat-bubble">
                      <span className="sh-chat-name">
                        {msg.sender === "chcustomer"
                          ? savedCustomer?.full_name || "You"
                          : "Support Team"}
                      </span>
                      <p>{msg.message}</p>
                      <span className="sh-chat-time">
                        {new Date(msg.created_at).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="sh-chat-input-row">
                <input
                  type="text"
                  placeholder="Type your message..."
                  value={chatInput}
                  onChange={(e) => setChatInput(e.target.value)}
                  onKeyPress={handleChatKey}
                  className="sh-chat-input"
                />
                <button className="sh-chat-send" onClick={sendChatMessage}>
                  <FaPaperPlane />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SupportHelpPage;
